export default {
    /*
     * Columnas
     */
    behavior_driver: 'Conductor',
    behavior_vehicle: 'Vehiculo',
    behavior_riskFactors: 'Factores de Riesgo',
    behavior_riskFactorsPoints: 'Factores de Riesgo (puntos)',
    behavior_category: 'Categoría',
    behavior_metric: 'Métrica',
    behavior_warningPoints: 'Advertencia (puntos)',
    behavior_violationPoints: 'Violación (puntos)',
    behavior_totalSafetyEvents: 'Eventos de seguridad total',
    behavior_total: 'Total',
    /*
     * Tipos de Métricas
     */

    behavior_aggression: 'Conducción Agresiva',
    behavior_hardBrake: 'Frenazo Brusco',
    behavior_hardTurn: 'Giro Brusco',
    behavior_rapidAcceleration: 'Aceleración Rápida',
    behavior_potentialIncident: 'Incidente potencial',
    behavior_driverMonitoringSystem: 'Sistema de Monitoreo del Conductor (DMS)',
    behavior_usingPhone: 'Uso de Teléfono',
    behavior_smoking: 'Fumando',
    behavior_drowsiness: 'Somnolencia',
    behavior_noSeatbelt: 'Sin cinturón de seguridad',
    behavior_dayDreaming: 'Pérdida de Atención',
    behavior_yawn: 'Bostezo',
    behavior_asleep: 'Conductor Dormido',
    behavior_distracted: 'Conductor Distraído',
    behavior_cameraObstructed: 'Cámara Obstruida',
    behavior_idleNoDriver: 'Inactiva sin Conductor',
    behavior_passengersDetection: 'Detección de Pasajeros',

    behavior_collisionWarning: 'Advertencia de Colisión',
    behavior_cyclistWarning: 'Advertencia de Ciclistas',
    behavior_passengerInside: 'Detección de Pasajeros',
    behavior_SpeedOver: 'Exceso de Velocidad',
    behavior_SpeedOverPosted: 'Exceso de Velocidad Permitida',
    behavior_ECUSpeedOver: 'Exceso de Velocidad ECU',
    behavior_ECUSpeedOverPosted: 'Exceso de Velocidad Permitida ECU',

    behavior_advancedDriverAssistanceSystem: 'Sistema ADAS',
    behavior_forwardCollisionWarning: 'Alerta de Colisión Frontal',
    behavior_closeFollowing: 'Distancia Corta',
    behavior_tailgating: 'Conducción Pegada',
    behavior_laneDeparture: 'Desvío de Carril',
    behavior_stopSignViolation: 'Omisión de Señal de Alto',
    behavior_pedestrianDetection: 'Detección de Peatón',
    behavior_cyclistDetection: 'Detección de Ciclista',
    behavior_vehicleSpeed: 'Velocidad del Vehículo',
    behavior_speedLabel: 'Velocidad > ',
    behavior_speedingOverPosted: 'Exceso de Velocidad sobre Límite',
    behavior_speedOverLow: '1-5 (Bajo)',
    behavior_speedOverMedium: '6-10 (Medio)',
    behavior_speedOverHigh: '11+ (Alto)',
    behavior_speedOverLowKph: '2-9 (Bajo)',
    behavior_speedOverMediumKph: '10-17 (Medio)',
    behavior_speedOverHighKph: '18+ (Alto)',

    behavior_today: 'Hoy',
    behavior_yesterday: 'Ayer',
    behavior_week: 'Esta semana',
    behavior_lastWeek: 'La semana pasada',
    behavior_thisMonth: 'Este Mes',
    behavior_lastMonth: 'El mes pasado',
    behavior_quarter: 'Este trimestre',
    behavior_lastQuarter: 'Ultimo trimestre',
    behavior_custom: 'Personalizado',
    behavior_last7days: 'Últimos 7 Dias',
    behavior_last15days: 'Últimos 15 Dias',
    behavior_last30Days: 'Últimos 30 Dias',

    behavior_dateToday: 'Hoy',
    behavior_dateYesterday: 'Ayer',
    behavior_dateThisWeek: 'Esta semana',
    behavior_dateLastToday: 'La semana pasada',
    behavior_dateThisMonth: 'Este Mes',
    behavior_dateLastMonth: 'El mes pasado',
    behavior_dateThisQuarter: 'Este trimestre',
    behavior_dateLastQuarter: 'Ultimo trimestre',
    behavior_dateCustom: 'Personalizado',
    behavior_dateLast7days: 'Últimos 7 Dias',
    behavior_dateLast15days: 'Últimos 15 Dias',
    behavior_dateLast30Days: 'Últimos 30 Dias',

    behavior_search: 'Buscar por {fields}',
    behavior_filterBy: 'Filtrar por:',
    behavior_tableNoData: 'No hay datos para mostrar en esta tabla.',
    behavior_noDataAvailable: 'No hay datos disponibles para el período de tiempo seleccionado.',
    behavior_timeFrame: 'Período de tiempo',
    behavior_singleUnits: 'Unidades',
    behavior_drivers: 'Conductores',
}
